import { schema, types } from 'papr'

const ALLOWED_TYPES = ['post', 'response']

export const reportedPostSchema = schema({
	reason: types.string(),
	reportedBy: types.objectId(),
	post: types.objectId(),
	responseId: types.string(),
	replyId: types.string(),
	responseStamp: types.string(),
	type: types.enum(ALLOWED_TYPES),
	dateAdded: types.date(),
})

export type ReportedPostDocument = (typeof reportedPostSchema)[0]
export type ReportedPostSchemaOptions = (typeof reportedPostSchema)[1]
